import { IErknmAgreementsPetitionOrganization } from 'APIPackage/KnmModule/interfaces/IErknmAgreementsPetitionOrganization';

import { IErknmFormAgreementPetitionOrganization } from '../interfaces/IErknmFormAgreementPetitionOrganization';

export const convertAgreementsPetitionOrganizationFormValuesToData = (
  petitionOrganization: IErknmFormAgreementPetitionOrganization | undefined,
): IErknmAgreementsPetitionOrganization | null => {
  if (!petitionOrganization) return null;

  return {
    inn: petitionOrganization?.inn || null,
    ogrn: petitionOrganization?.ogrn || null,
    organizationName: petitionOrganization?.organizationName || null,
    subjectType: petitionOrganization?.subjectType || null,
    rafpNza: petitionOrganization?.rafpNza || null,
    kpp: petitionOrganization?.kpp || null,
    country: petitionOrganization?.country || null,
    locationAddress: petitionOrganization?.locationAddress || null,
    factualAddress: petitionOrganization?.factualAddress || null,
    workAddress: petitionOrganization?.workAddress || null,
    snils: petitionOrganization?.snils || null,
    document: petitionOrganization?.document || null,
    isAutocomplete: petitionOrganization?.isAutocomplete || null,
    smevRequestStatus: petitionOrganization?.smevRequestStatus || null,
    checkSubjectResult: petitionOrganization?.checkSubjectResult || null,
  };
};
